import React from 'react';

// RGV Smart Pay brand logo — inline SVG, no image assets needed.
// Props:
//   size: 'sm' | 'md' | 'lg'
//   mono: true = white version for dark backgrounds
//   showName: false = icon mark only
const SIZES = {
  sm: { icon: 26, rgv: 14, tag: 9,  gap: 8  },
  md: { icon: 34, rgv: 18, tag: 11, gap: 10 },
  lg: { icon: 44, rgv: 23, tag: 14, gap: 12 },
};

const Logo = ({ mono = false, size = 'md', showName = true, className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  const text  = mono ? '#ffffff' : '#0f172a';
  const blue  = '#3b82f6';
  const white = '#ffffff';

  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', gap: s.gap, lineHeight: 1 }}
    >
      {/* ── Icon mark ── */}
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 40 40"
        fill="none"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
      >
        {/* Badge background */}
        <rect width="40" height="40" rx="9" fill={mono ? 'rgba(255,255,255,0.15)' : '#0f172a'} />

        {/* Geometric "R" — stem */}
        <rect x="10" y="9" width="5" height="22" rx="1.5" fill={white} />

        {/* Geometric "R" — bowl (half arch) */}
        <path
          d="M15 9 Q27 9 27 16 Q27 23 15 23"
          stroke={white}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />

        {/* Geometric "R" — leg (diagonal) */}
        <line x1="15" y1="23" x2="26" y2="31"
          stroke={white} strokeWidth="5" strokeLinecap="round" />

        {/* Electric blue accent dot — bottom-right */}
        <circle cx="32" cy="30" r="4" fill={blue} />
      </svg>

      {/* ── Wordmark ── */}
      {showName && (
        <span style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <span style={{
            fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 900,
            fontSize: s.rgv,
            letterSpacing: '-0.02em',
            color: text,
            lineHeight: 1,
          }}>
            RGV
          </span>
          <span style={{
            fontFamily: "'Arial', 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 700,
            fontSize: s.tag,
            letterSpacing: '0.1em',
            color: blue,
            textTransform: 'uppercase',
            lineHeight: 1,
          }}>
            Smart Pay
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
